export default "__VITE_ASSET__CLKYkNaO__"